import { api } from './apiClient';

export interface HomepageConfigItem {
  id: number;
  pId: number;
  sdkProductId: number;
  code: string;
  name: string;
  title: string;
  category: string;
  shopProductId?: string;
  imageUrl?: string;
  jumpUrl?: string;
  jumpType?: string;
  status: number;
  seq: number;
  beginTime: string;
  endTime?: string;
  isExist: number;
  gmtCreate: string;
  gmtModified: string;
  remark?: string;
  children?: HomepageConfigItem[];
}

export interface HomepageConfigArea {
  id: string;
  name: string;
  items: HomepageConfigItem[];
}

export const homepageConfigService = {
  // 获取首页配置树形结构
  getHomepageTree: async () => {
    return api.get('/admin/homepage/tree');
  },

  // 获取配置项详情
  getConfigDetail: async (id: number) => {
    return api.get('/admin/homepage/detail', { params: { id } });
  },

  // 保存配置项
  saveConfig: async (data: any) => {
    return api.post('/admin/homepage/save', data);
  },

  // 更新配置项
  updateConfig: async (data: any) => {
    return api.post('/admin/homepage/update', data);
  },

  // 操作配置项
  operationConfig: async (id: number, operation: 'enable' | 'disable' | 'delete') => {
    return api.post('/admin/homepage/operation', null, {
      params: {
        id: id.toString(),
        operation,
      },
    });
  },

  // 更新排序
  updateSort: async (id: number, seq: number, pId?: number) => {
    const params: any = { 
      id: id.toString(),
      seq: seq.toString()
    };
    if (pId !== undefined && pId > 0) {
      params.pId = pId.toString();
    }
    return api.post('/admin/homepage/updateSort', null, { params });
  }
};
